<template>
  <!-- 课程首页 -->
  <div class="c-course-wrap" v-wechat-title="courseInfo.name" gxxt-loading="loading">
    <open-app-bar
      class="fixed-top"
      :showHome="true"
      v-if="!showTimetableEnter"
      :open-app-info="{
        jumpType: jumpType,
        resourceId: courseInfo.resourceId,
        goodsType: goodsType,
        goodsId: goodsId,
      }"
    ></open-app-bar>
    <div
      class="c-open-timetable-bar"
      v-if="courseInfo && courseInfo.type!=-1 && showTimetableEnter"
    >
      <img src="@/assets/images/gxxt.png" alt />
      <router-link :to="{path:'/timetable', query: {goodsType: courseInfo.type}}">
        <GxxtButton round size="xs">
          <span class="color-6">
            <i class="iconfont icon-shijian f32"></i>
            全年课表
          </span>
        </GxxtButton>
      </router-link>
    </div>
    <div class="c-head-box">
      <div v-if="!showLiveVideo" class="c-course-thumb c-default-img">
        <img v-if="courseInfo.imageA" :src="courseInfo.imageA" alt />
      </div>
      <div v-else class="c-video">
        <div id="J_prismPlayer"></div>
      </div>
    </div>
    <course-info :course-info="courseInfo" :memberVip="vipInfo.memberVip" :goods-type="goodsType"></course-info>
    <!-- 最近参与用户 -->
    <!-- <user-list
      :goodsType="goodsType"
      :resource-id="courseInfo.resourceId"
      :adminId="adminId"
      :goodsId="goodsId"
    ></user-list>-->
    <div class="c-tabs">
      <gxxt-tab v-model="currentTab" @tab-click="changeTab" plr="50">
        <gxxt-tab-pane name="intro" label="简介">
          <div
            class="c-teacher-info"
            v-if="goodsType == constants.goodsType.course || goodsType == constants.goodsType.training"
          >
            <div class="c-default-img">
              <img v-if="courseInfo.teacherSquareImage" :src="courseInfo.teacherSquareImage" alt />
            </div>
            <div class="text">
              <span class="f32 color-222 fb">{{courseInfo.teacherName}}</span>
              <span class="f28 color-A mt10 tl">{{courseInfo.teacherDescription}}</span>
            </div>
          </div>
          <introduction :html="courseInfo.content"></introduction>
        </gxxt-tab-pane>
        <gxxt-tab-pane
          v-if="goodsType == constants.goodsType.training || goodsType == constants.goodsType.course"
          name="list"
          label="目录"
          :superscript="courseInfo.hasTryLesson && !courseInfo.hasReadPermission ? '试看' : ''"
          superscript-bg-color="#f50"
          superscript-color="#fff"
          superscript-size="22"
        >
          <list
            :query="{resourceId: courseInfo.resourceId, goodsType: goodsType, goodsId: goodsId}"
          ></list>
        </gxxt-tab-pane>
        <gxxt-tab-pane name="comment" label="评价" :superscript="counts" gxxt-loading="loadComments">
          <comment :goodsType="goodsType" :goodsId="goodsId"></comment>
        </gxxt-tab-pane>
      </gxxt-tab>
    </div>
    <footer-bar
      v-if="studyQueryObj.originEntry != 'my-course'"
      :memberVip="vipInfo.memberVip"
      :goods-type="goodsType"
      :courseInfo="courseInfo"
      :query="{
        id: goodsId,
        studyQuery: studyQuery,
        adminId: adminId,
        mobile: userInfo.mobile,
        resourceId: courseInfo.resourceId,
        goodsType: courseInfo.type,
        isGoodsGroup: isGoodsGroup,
        origin: origin}"
    ></footer-bar>
  </div>
</template>
<script>
import dates from '@/utils/dates'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
import { setShareInfo, saveFromRoute, getFromRoute } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
import { GxxtButton, GxxtTab, GxxtTabPane } from '@/components'
import introduction from './components/introduction.vue'
import UserList from './components/user-list.vue'
import footerBar from './components/footer-bar.vue'
import CourseInfo from './components/course-info.vue'
import comment from './components/comment.vue'
import list from './components/list/index.vue'
import { useRoute } from 'vue-router'
import { ref, onMounted, nextTick } from 'vue'
import { getGoodsCommentCount } from '@/api/modules/course'
export default {
  components: {
    GxxtButton,
    GxxtTab,
    GxxtTabPane,
    introduction,
    UserList,
    footerBar,
    CourseInfo,
    comment,
    list,
  },
  setup(props) {
    const $route = useRoute()
    const counts = ref(0)
    const getCount = async () => {
      let res = await getGoodsCommentCount({ goodsId: $route.query.goodsId })
      if (res && res.code == 200) {
        counts.value = res.data
      }
    }
    onMounted(() => {
      getCount()
    })
    return {
      counts,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if (from.name == 'timetable') {
      //   vm.showTimetableEnter = true
      //   saveFromRoute('timetable')
      // } else {
      //   if (getFromRoute() == 'timetable') {
      //     vm.showTimetableEnter = true
      //     saveFromRoute('timetable')
      //   } else {
      //     vm.showTimetableEnter = false
      //     saveFromRoute(from.name)
      //   }
      // }
      vm.init()
    })
  },
  data() {
    return {
      // 链接上的参数
      goodsId: null,
      goodsType: '',
      origin: '', //课程表那边的来源参数
      adminId: null,
      studyQuery: '',
      studyQueryObj: {},
      isGoodsGroup: false, //true 团购  false 个人
      courseInfo: {
        type: -1,
      },
      userInfo: {},
      jumpType: '',
      vipInfo: {},
      showTimetableEnter: false,
      dates,
      currentTab: 'intro',
      loading: false,
      beforeScrollTop: 0,
      isLoadingMore: false,
      loadComments: false,
      showLiveVideo: false,
      player: null,
    }
  },
  mounted() {
    // this.init()
  },
  methods: {
    init() {
      this.goodsId = this.$route.query.goodsId
      this.adminId = this.$route.query.adminId ? this.$route.query.adminId : ''
      this.origin = this.$route.query.origin //课程那边需要的参数来源
      this.goodsType = this.$route.query.goodsType
      this.studyQuery = this.$route.query.studyQuery
      this.studyQueryObj = this.studyQuery
        ? JSON.parse(decodeURIComponent(this.studyQuery))
        : ''
      if (this.studyQueryObj.originEntry == 'my-course') {
        nextTick(() => {
          this.currentTab = 'list'
        })
      }
      if (this.$route.query.from == 'timetable') {
        this.showTimetableEnter = true
      }
      if (this.$route.query.from == 'live-broadcast-list') {
        // 直播，展示视频
        this.getLiveMaterialUrl()
      }

      this.getCourseInfo()
      this.getIsGoodsGroup()
      this.isMemberVip()
    },
    // tab切换
    changeTab(v) {
      if (v == 'comment') {
        this.bindScroll()
      } else {
        this.removeScroll()
      }
    },
    setJumpType(hasPermission) {
      if (this.goodsType == this.constants.goodsType.column) {
        this.jumpType = 2
      } else {
        if (hasPermission) {
          this.jumpType = 1
        } else {
          this.jumpType = 2
        }
      }
    },
    // 获取直播回放视频连接
    async getLiveMaterialUrl() {
      let res = await this.api.course.getLiveMaterialUrl()
      if (res && res.code == 200 && res.data) {
        this.showLiveVideo = true
        nextTick(() => {
          this.initPlay(res.data)
        })
      }
    },
    initPlay(url) {
      this.player = new Aliplayer(
        {
          id: 'J_prismPlayer',
          source: url,
          format: 'm3u8',
          mediaType: 'audio',
          width: '100%',
          // height: 422 * this.ratio + 'px',
          height: '100%',
          autoplay: false,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'click',
          useH5Prism: true,
          cover: this.courseInfo.imageA,
        },
        function (player) {
          // console.log('The player is created')
        }
      )
      this.player.on('completeSeek', () => {
        document.getElementsByClassName('prism-thumbnail')[0].style.display =
          'none'
      })
    },
    //获取课程信息
    async getCourseInfo() {
      this.loading = true
      let res = await this.api.groupBuying.getCourseInfo(
        this.goodsId,
        this.adminId
      )
      this.loading = false
      if (res && res.code == 200) {
        if (this.studyQueryObj.originEntry == 'my-course') {
          res.data.hasTryLesson = false
        }
        this.courseInfo = res.data
        if (!this.goodsType) {
          // 兼容老版本
          this.goodsType = res.data.type
        }
        this.setJumpType(this.courseInfo.hasReadPermission)
        // 设置分享
        let shareInfo = {
          title: this.courseInfo.shareName || this.courseInfo.name,
          desc: this.courseInfo.shareDescription,
          link: this.courseInfo.shareLink,
          imgUrl: this.courseInfo.shareImage,
        }
        setShareInfo(shareInfo)
        wxShare({
          shareInfo,
        })
      }
    },
    //区分个人还是团购
    async getIsGoodsGroup() {
      let res = await this.api.groupBuying.isGoodsGroup(this.goodsId)
      if (res && res.code == 200) {
        this.isGoodsGroup = res.data
      }
    },
    //是否是VIP
    isMemberVip() {
      // let res = await this.api.vip.isMemberVip()
      // if (res && res.code == 200) {
      //   this.vipInfo = res.data
      // }
      this.vipInfo = {
        memberVip: 0,
      }
    },
    getUserList() {
      this.$router.push({
        path: '/user-list',
        query: {
          id: this.goodsId,
        },
      })
    },
    loadMoreFn() {
      if (this.isLoadingMore) {
        return false
      }
      this.isLoadingMore = true
      console.log('load more')
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
  },
  unmounted() {
    this.removeScroll()
    this.player && this.player.dispose()
  },
}
</script>
<style lang="less" scoped>
.c-teacher-info {
  display: flex;
  padding: 20px 32px 30px;
  margin-top: 20px;
  background: #ffffff;
  margin-bottom: -40px;
  .c-default-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-right: 20px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    span {
      color: #aaa;
    }
  }
}
.c-open-timetable-bar {
  width: 750px;
  height: 90px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f5f4;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  i {
    position: relative;
    top: 2px;
    color: #878787;
  }

  img {
    width: 139px;
    height: 50px;
  }
}
.c-course-wrap {
  background: #f5f5f5;
  overflow-x: hidden;
  padding-top: 90px;
  .c-head-box {
    .c-course-thumb {
      width: 750px;
      height: 422px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .c-video {
      width: 750px;
      height: 422px;
      position: relative;
      z-index: 1;
      background: #fff;
    }
  }
  .c-tabs {
    padding: 30px 0 300px;
    background-color: #fff;
    margin-top: 20px;
  }
}
</style>
